import { render, staticRenderFns } from "./OutpatientReviewCpts.vue?vue&type=template&id=9ef6b02e&scoped=true&"
import script from "./OutpatientReviewCpts.vue?vue&type=script&lang=js&"
export * from "./OutpatientReviewCpts.vue?vue&type=script&lang=js&"
import style0 from "./OutpatientReviewCpts.vue?vue&type=style&index=0&id=9ef6b02e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef6b02e",
  null
  
)

export default component.exports